import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GlobalErrorStateType } from 'src/shared/types/src';

const initialState: GlobalErrorStateType = {
    isError: false,
    message: ''
}

const globalErrorSlice = createSlice({
    name: 'globalErrorSlice',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<GlobalErrorStateType>) => {
            state.isError = action.payload.isError;
            state.message = action.payload.message;
        }
    }
});

export const GlobalErrorActions = globalErrorSlice.actions;
export default globalErrorSlice.reducer;
